import { IGridSettings, IImageSettings, Image, RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
import { IWineClub } from '../../../settings/app.settings';
import { WineClubDataStore } from '../wine-club-data';
import { IWineClubSignupResources } from '../wine-club-signup.props.autogenerated';
export interface IClub {
    id: number;
    club: IWineClub;
    resources: IWineClubSignupResources;
    gridSettings: IGridSettings;
    imageSettings?: IImageSettings;
}

export interface IClubState {
    additionalBenefitsState: boolean;
}

/**
 * responsible for rendering a single wine club item
 */
export class Club extends React.Component<IClub, IClubState> {

    private _clubDataStore: WineClubDataStore | undefined;

    public constructor(props: IClub) {
        super(props);

        this._onWineClubSelect = this._onWineClubSelect.bind(this);

        this.state = {
            additionalBenefitsState: false
        };

        this._clubAdditionalBenefits = this._clubAdditionalBenefits.bind(this);
    }

    public componentDidMount(): void {
        this._clubDataStore = WineClubDataStore.getInstance();
        this.setState({});
    }

    public render(): JSX.Element {

        // SSR will never ready club so return empty
        if (!this._clubDataStore) { return <div />; }

        const store = this._clubDataStore.get();

        let activeClass = 'wine-club-signup-club-item';
        if (store.clubId === this.props.id) {
            activeClass = 'wine-club-signup-club-item active';
        }

        let benefitsCSS = 'closed';
        if (this.state.additionalBenefitsState) {
            benefitsCSS = 'open';
        }

        return (
            <div className={`${activeClass} ${this._parseToCSS(this.props.club.title)}`}>
                <div className='wine-club-signup-club-item-image'>
                    <Image {...this.props.club.clubImage} gridSettings={this.props.gridSettings} />
                </div>
                <div className='wine-club-signup-club-item-content'>
                    <div className='wine-club-signup-club-item-content-header'>
                        <div className='wine-club-signup-club-item-title'>
                            {this.props.club.title}
                        </div>
                        <div className='wine-club-signup-club-item-subtitle'>
                            {this.props.club.subHeader}
                        </div>
                    </div>
                    <div className='wine-club-signup-club-item-content-body'>
                        <div className='wine-club-signup-club-item-pricing'>
                            <div className='wine-club-signup-club-item-pricing-range'>
                                <RichTextComponent text={this.props.club.priceRange} />
                            </div>
                            <span className='wine-club-signup-club-item-pricing-cost-notif'>{this.props.resources.wineClubSignup__shipApproxCost}</span>
                        </div>
                        <div className='wine-club-signup-club-item-description'>
                            <RichTextComponent text={this.props.club.description} />
                        </div>
                        <div className={`wine-club-signup-club-item-additional-benefits ${!this.props.club.additionalBenefits ? 'empty' : ''}`}>
                            <button
                                className={`wine-club-signup-club-item-additional-benefits-button ${benefitsCSS}`}
                                onClick={this._clubAdditionalBenefits}
                            >
                                {this.props.resources.wineClubSignup__clubAdditionalBenefits}
                            </button>
                            <div className={`wine-club-signup-club-item-additional-benefits-content ${benefitsCSS}`}>
                                {this.props.club.additionalBenefits && <div className={`wine-club-signup-club-item-additional-benefits-title ${benefitsCSS ? 'hide' : 'display'}`}>{this.props.resources.wineClubSignup__clubAdditionalBenefits}</div>}
                                <RichTextComponent text={this.props.club.additionalBenefits} />
                            </div>
                        </div>
                        <div className='wine-club-signup-club-item-button'>
                            <button onClick={this._onWineClubSelect} disabled={store.clubId === this.props.id} >
                                {
                                    store.clubId === this.props.id ? this.props.resources.wineClubSignup__clubSelected : this.props.resources.wineClubSignup__selectClub
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private _clubAdditionalBenefits(): void {
        this.setState({
            additionalBenefitsState: !this.state.additionalBenefitsState
        });
    }

    private _onWineClubSelect(): void {
        this._clubDataStore!.reset();
        const store = this._clubDataStore!.get();
        this._clubDataStore!.edit({
            ...store,
            clubId: this.props.id
        });
    }

    private _parseToCSS(parseString: string): string {
        // please no exotic characters thanks
        return parseString.toLowerCase().replace(/ /g, '-').replace(/\+/g, '-plus');
    }
}